"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIAssistTimingHelper = void 0;
/**
 * Static helper class for timeout and timing operations
 */
class AIAssistTimingHelper {
    /**
     * Create a debounced function that delays execution
     */
    static debounce(func, delay) {
        let timeoutId = null;
        return (...args) => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func(...args);
                timeoutId = null;
            }, delay);
        };
    }
    /**
     * Clear timeout safely
     */
    static clearTimeout(timeout) {
        if (timeout) {
            clearTimeout(timeout);
        }
    }
    /**
     * Set timeout with logging
     */
    static setTimeoutWithLogging(callback, delay, logMessage) {
        return setTimeout(() => {
            callback();
        }, delay);
    }
    /**
     * Validate if enough time has passed for analysis
     */
    static shouldTriggerAnalysis(isLLMStreaming, textLength, minTextLength = 20) {
        return !isLLMStreaming && textLength >= minTextLength;
    }
}
exports.AIAssistTimingHelper = AIAssistTimingHelper;
